import swal from "sweetalert";

function successAlert(title) {
    swal({  
        text: title,  
        icon: "success",  
        button: "close",  
      });  
}

function confirmationAlert(
  title,
  text,
  type,
  confirmButtonText,
  cancelButtonText,
  confirmAction,
  cancelAction
) {
  const swalWithBootstrapButtons = swal.mixin({
    customClass: {
      confirmButton: "btn btn-info",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  swalWithBootstrapButtons
    .fire({
      title,
      text,
      type,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f68681",
      cancelButtonColor: "#d69911",
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick: false,
    })
    .then(result => {
      if (result.value) {
        confirmAction();
      } else if (result.dismiss === swal.DismissReason.cancel) {
        cancelAction();
      }
    });
}
function warningAlert(title) {
 swal({  
    text: title,  
    icon: "warning",  
    button: "close",  
  });  
}

export { successAlert, confirmationAlert,warningAlert };
